import CqrsClient from "./cqrsClient";

const cqrsClient = new CqrsClient({ baseUri: "/umbraco/api/Store/" });

export function GetShippingPrice(shippingMethodSku, distance, quantity) {
    return cqrsClient.query({
        $type: "SkoltHolding.Core.Models.Queries.GetShippingPriceQuery, SkoltHolding.Core",
        shippingMethodSku,
        distance,
        quantity
    })
}

export default {
    GetShippingPrice
}